import React from 'react';
import Modal from 'react-bootstrap/Modal';

interface Props {
  show: boolean;
  onHide: () => any;
  centered?: boolean;
  backdrop?: boolean | 'static';
  className?: string;
  title?: string;
  subTitle?: string;
  closeButton?: boolean;
  headerClassName?: string;
  children: React.ReactNode | React.ReactNode[];
  footerContent?: React.ReactNode;
  footerClassName?: string;
  isSecondModal?: boolean;
  size?: 'sm' | 'lg' | 'xl';
}

const ModalWrapper = ({ show, onHide, centered, backdrop, className, title, subTitle, closeButton, headerClassName, children, footerContent, footerClassName, isSecondModal, size }: Props) => {
  return (
    <Modal show={show} onHide={onHide} centered={centered} backdrop={backdrop} className={className} backdropClassName={isSecondModal ? 'custom-backdrop' : ''} size={size? size : undefined}>
      <ModalHeader closeButton={closeButton} className={headerClassName}>
        <div>
          {title && <h5 className='m-0'>{title}</h5>}
          {subTitle && <p className='m-0'>{subTitle}</p>}
        </div>
      </ModalHeader>
      <Modal.Body>{children}</Modal.Body>
      {footerContent && <Modal.Footer className={footerClassName}>{footerContent}</Modal.Footer>}
    </Modal>
  );
};

export const ModalHeader = ({ closeButton, className, children }: { closeButton?: boolean; className?: string; children: React.ReactNode }) => {
  return (
    <Modal.Header closeButton={closeButton} className={`border-0 align-items-baseline ${className}`}>
      {children}
    </Modal.Header>
  );
};

export const ModalFooter = ({ className, children }: { className?: string; children: React.ReactNode }) => {
  return <Modal.Footer className={`border-0 pb-4 ${className}`}>{children}</Modal.Footer>;
};

export default ModalWrapper;
